import axiosInstance from "../utils/axiosInstance";

export const login = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/login/`,
        formData
    );
    return data;
};

export const passwordReset = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/password-reset/`,
        formData
    );
    return data;
};

export const resetPassword = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/password-reset-confirm/`,
        formData
    );
    return data;
};

export const register = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/register/`,
        formData
    );
    return data;
};

export const getProducts = async (page='', id='', name='', price='', upc='', description='', isDigital='', isInventoryTrackingEnabled='', stock='', taxType='', taxPercentage='', owner='', status='', created='', updated='', records='') => {
    if (page === ''){
        const { data } = await axiosInstance.get(
            `/api/v1/product/?records=${records}&page=${page}&id=${id}&name=${name}&price=${price}&upc=${upc}&description=${description}&is_digital=${isDigital}&is_inventory_tracking_enabled=${isInventoryTrackingEnabled}&stock=${stock}&tax_type=${taxType}&tax_percentage=${taxPercentage}&owner=${owner}&status=${status}&created=${created}&updated=${updated}`
        );
        return data;
    }
    else {
        const { data } = await axiosInstance.get(
            `/api/v1/product/?records=${records}&page=${page}&id=${id}&name=${name}&price=${price}&upc=${upc}&description=${description}&is_digital=${isDigital}&is_inventory_tracking_enabled=${isInventoryTrackingEnabled}&stock=${stock}&tax_type=${taxType}&tax_percentage=${taxPercentage}&owner=${owner}&status=${status}&created=${created}&updated=${updated}`
        );
        return data;
    }
};

export const importProducts = (formData) => {
    return axiosInstance.post('/api/v1/product/import/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

export const downloadImportTemplate = () => {
    return axiosInstance.get('/api/v1/product/import/download-template/', { responseType: 'blob' });
};

export const getCountry = async (page = '', id = '', name = '', created = '', updated = '', records = '') => {
    const { data } = await axiosInstance.get(
        `/api/v1/country/?records=${records}&page=${page}&id=${id}&name=${name}&created=${created}&updated=${updated}`
    );
    return data;
};

export const getState = async (page = '', id = '', name = '', country = '', created = '', updated = '', records = '') => {
    const { data } = await axiosInstance.get(
        `/api/v1/state/?records=${records}&page=${page}&id=${id}&name=${name}&country=${country}&created=${created}&updated=${updated}`
    );
    return data;
};

export const getCity = async (page = '', id = '', name = '', state = '', created = '', updated = '', records = '') => {
    const { data } = await axiosInstance.get(
        `/api/v1/city/?records=${records}&page=${page}&id=${id}&name=${name}&state=${state}&created=${created}&updated=${updated}`
    );
    return data;
};

export const addProducts = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/product/`,
        formData
    );
    return data;
};

export const changeProductStatus = async ({productStatus, productId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/product/${productId}/`,
            productStatus
        )
    return data
};

export const changePaymentStatus = async ({paymentStatus, orderId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/order/${orderId}/`,
            paymentStatus
        )
    return data
};

export const changeProductInventoryTrackingStatus = async ({productInventoryTrackingStatus, productId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/product/${productId}/`,
            productInventoryTrackingStatus
        )
    return data
};

export const changeCouponInventoryTrackingStatus = async ({couponInventoryTrackingStatus, couponId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/coupon/${couponId}/`,
            couponInventoryTrackingStatus
        )
    return data
};

export const editProduct = async ({formData, productId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/product/${productId}/`,
            formData
        )
    return data
};

export const productSetting = async ({formData, productId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/product/${productId}/`,
            formData
        )
    return data
};

export const productStockUpdate = async ({formData}) => {
    const { data } = await axiosInstance
        .post(
            `/api/v1/product-stock-transaction/`,
            formData
        )
    return data
}

export const couponStockUpdate = async ({formData}) => {
    const { data } = await axiosInstance
        .post(
            `/api/v1/coupon-stock-transaction/`,
            formData
        )
    return data
}

export const getProductStock = async (page=1, id, stock_id, name, stock, type, date) => {
    const {data} = await axiosInstance.get(`/api/v1/product-stock-transaction/?page=${page}&id=${stock_id}&product=${id}&name=${name}&stock=${stock}&type=${type}&created=${date}`);
    return data;
}

export const getCouponStock = async (page=1, id, stock_id, name, stock, type, date) => {
    const {data} = await axiosInstance.get(`/api/v1/coupon-stock-transaction/?page=${page}&id=${stock_id}&coupon=${id}&name=${name}&stock=${stock}&type=${type}&created=${date}`);
    return data;
}

export const getAddOnProducts = async (page=1, id, name, price, description, stock, status, upc, date, isDigital, updated, records) => {
    const { data } = await axiosInstance.get(
        `/api/v1/add-on-product/?records=${records}&page=${page}&id=${id}&name=${name}&price=${price}&description=${description}&stock=${stock}&status=${status}&upc=${upc}&created=${date}&is_digital=${isDigital}&updated=${updated}`
    );
    return data;
};

export const addAddOnProducts = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/add-on-product/`,
        formData
    );
    return data;
};

export const changeAddOnProductStatus = async ({addOnProductStatus, addOnProductId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/add-on-product/${addOnProductId}/`,
            addOnProductStatus
        )
    return data
};

export const changeAddOnProductInventoryTrackingStatus = async ({addOnProductInventoryTrackingStatus, addOnProductId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/add-on-product/${addOnProductId}/`,
            addOnProductInventoryTrackingStatus
        )
    return data
};

export const editAddOnProduct = async ({formData, addOnProductId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/add-on-product/${addOnProductId}/`,
            formData
        )
    return data
};

export const addOnProductSetting = async ({formData, addOnProductId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/add-on-product/${addOnProductId}/`,
            formData
        )
    return data
};

export const addOnProductStockUpdate = async ({formData}) => {
    const { data } = await axiosInstance
        .post(
            `/api/v1/add-on-product-stock-transaction/`,
            formData
        )
    return data
}

export const getAddOnProductStock = async (page=1, id, stockTransactionID, name, stock, type, date) => {
    const {data} = await axiosInstance.get(`/api/v1/add-on-product-stock-transaction/?page=${page}&id=${stockTransactionID}&add_on_product=${id}&name=${name}&stock=${stock}&type=${type}&created=${date}`);
    return data;
}

export const getProductGroups = async (page=1, id = '', name = '', description = '', price = '', status = '', created = '', updated = '',tax_type = '',tax_percentage = '', records) => {
    const { data } = await axiosInstance.get(
        `/api/v1/product-group/?records=${records}&page=${page}&id=${id}&name=${name}&description=${description}&price=${price}&status=${status}&created=${created}&updated=${updated}&tax_type=${tax_type}&tax_percentage=${tax_percentage}`
    );
    return data;
};

export const changeProductGroupStatus = async ({productGroupStatus, productGroupId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/product-group/${productGroupId}/`,
            productGroupStatus
        )
    return data
};

export const editProductGroup = async ({formData, productGroupId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/product-group/${productGroupId}/`,
            formData
        )
    return data
};

export const addProductGroup = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/product-group/`,
        formData
    );
    return data;
};

// Matches name, email or phone (the API ignores spaces, dashes and a +91 / leading-0 prefix)
export const searchCustomers = async (page = 1, search = '', records = 10) => {
    const { data } = await axiosInstance.get('/api/v1/customer/', {
        params: { page, search, records },
    });
    return data;
};

export const getCustomers = async (page=1, id='', name='', email='', phone='', is_vip='', credit_limit='', amount_due='', due_date='', created_date='', updated='', records='', country='', state='', city='', pincode='', address_line1='', address_line2='') => {
    if (page === ''){
        const { data } = await axiosInstance.get(
            `/api/v1/customer/?records=${records}&id=${id}&name=${name}&email=${email}&phone=${phone}&is_vip=${is_vip}&credit_limit=${credit_limit}&amount_due=${amount_due}&due_date=${due_date}&created_date=${created_date}&updated=${updated}&country=${country}&state=${state}&city=${city}&pincode=${pincode}`
        );
        return data;
    }
    else {
        const { data } = await axiosInstance.get(
            `/api/v1/customer/?records=${records}&page=${page}&id=${id}&name=${name}&email=${email}&phone=${phone}&is_vip=${is_vip}&credit_limit=${credit_limit}&amount_due=${amount_due}&due_date=${due_date}&created_date=${created_date}&updated=${updated}`
        );
        return data;
    }
};

// export const getCountry = async (page = '', id = '', name = '', created = '', updated = '', records = '') => {
//     const { data } = await axiosInstance.get(
//         `/api/v1/country/?records=${records}&page=${page}&id=${id}&name=${name}&created=${created}&updated=${updated}`
//     );
//     return data;
// };
//
// export const getState = async (page = '', id = '', name = '', country = '', created = '', updated = '', records = '') => {
//     const { data } = await axiosInstance.get(
//         `/api/v1/state/?records=${records}&page=${page}&id=${id}&name=${name}&country=${country}&created=${created}&updated=${updated}`
//     );
//     return data;
// };
//
// export const getCity = async (page = '', id = '', name = '', state = '', created = '', updated = '', records = '') => {
//     const { data } = await axiosInstance.get(
//         `/api/v1/city/?records=${records}&page=${page}&id=${id}&name=${name}&state=${state}&created=${created}&updated=${updated}`
//     );
//     return data;
// };

export const editCustomer = async ({formData, customerId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/customer/${customerId}/`,
            formData
        )
    return data
};

// export const updateCustomerShippingAddress = async ({formData, customerShippingAddressId}) => {
//     const { data } = await axiosInstance
//         .patch(
//             `/api/v1/customer-shipping-address/${customerShippingAddressId}/`,
//             formData
//         )
//     return data
// };

export const updateCustomerShippingAddress = async ({ formData, customerShippingAddressId }) => {
    console.log("frrrrm dataaa", formData)
    console.log("frrrrm customerShippingAddressId", customerShippingAddressId)
    const { data } = await axiosInstance.patch(
        `/api/v1/customer-shipping-address/${customerShippingAddressId}/`,
        formData
    );
    return data;
};

export const createCustomerShippingAddress = async ({ formData }) => {
    const { data } = await axiosInstance.post(
        `/api/v1/customer-shipping-address/`,
        formData
    );
    return data;
};


export const addCustomer = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/customer/`,
        formData
    );
    return data;

};

export const getCart = async (page=1, id, customer, cart_items, cart_items_total, cart_total, discount, tax_amount, coupon, created, updated, records) => {
    const { data } = await axiosInstance.get(
        `/api/v1/cart/?records=${records}&page=${page}&id=${id}&customer=${customer}&cart_items=${cart_items}&cart_items_total=${cart_items_total}&cart_total=${cart_total}&discount=${discount}&tax_amount=${tax_amount}&coupon=${coupon}&created=${created}&updated=${updated}`
    );
    return data;
};

export const editCart = async ({formData, cartId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/cart/${cartId}/`,
            formData
        )
    return data
};

export const editCartItems = async ({formData, cartItemId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/cart-item/${cartItemId}/`,
            formData
        )
    return data
};

export const deleteCartItems = async ({cartItemId}) => {
    const { data } = await axiosInstance
        .delete(
            `/api/v1/cart-item/${cartItemId}/`,
        )
    return data
};


export const getCoupons = async (
    page = 1, id, code, name, value, type, percentage, stock, status, minimumCartValue, maxCouponValue,
    eligibleForFirstOrderOnly, applicableTo, created, updated = ''
) => {
    const { data } = await axiosInstance.get(
        `/api/v1/coupon/?page=${page}&id=${id}&code=${code}&name=${name}&value=${value}&type=${type}&percentage=${percentage}&stock=${stock}&status=${status}&minimum_cart_value=${minimumCartValue}&max_coupon_value=${maxCouponValue}&eligible_for_first_order_only=${eligibleForFirstOrderOnly}&applicable_to=${applicableTo}&created=${created}&updated=${updated}`
    );
    return data;
};

export const getCustomerShippingAddresses = async (
    page = 1, customer
) => {
    const { data } = await axiosInstance.get(
        `/api/v1/customer-shipping-address/?customer=${customer}`
    );
    return data;
};

export const updateCartShippingAddress = async ({ cartId, shippingAddress }) => {
    const payload = {
        shipping_address: shippingAddress || null
    };

    const { data } = await axiosInstance.patch(
        `/api/v1/cart/${cartId}/`,
        payload
    );

    return data;
};


export const changeCouponStatus = async ({couponStatus, couponId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/coupon/${couponId}/`,
            couponStatus
        )
    return data
};

export const editCoupon = async ({payload, couponId}) => {
    console.log("payload", payload)
    const { data } = await axiosInstance
        .patch(
            `/api/v1/coupon/${couponId}/`,
            payload
        )
    return data
};

export const addCoupon = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/coupon/`,
        formData
    );
    return data;
};

export const getTransactions = async (page=1, id, order, transactionStatus, amount, currency, paymentMode,
                                      created, updated) => {
    const { data } = await axiosInstance.get(
        `/api/v1/transaction/?page=${page}&id=${id}&order=${order}&transaction_status=${transactionStatus}&amount=${amount}&currency=${currency}&payment_mode=${paymentMode}&created=${created}&updated=${updated}`
    );
    return data;
};

export const getOrders = async (page=1, id, orderNumber, orderCustomerName, orderTotalAmount, orderStatus,
                                orderPaymentMethod, orderPaymentStatus) => {
    const { data } = await axiosInstance.get(
        `/api/v1/order/?page=${page}&id=${id}&order_number=${orderNumber}&customer=${orderCustomerName}&total_amount=${orderTotalAmount}&order_status=${orderStatus}&payment_method=${orderPaymentMethod}&payment_status=${orderPaymentStatus}`
    );
    return data;
};

export const getOrder = async (orderId) => {
    const { data } = await axiosInstance.get(`/api/v1/order/${orderId}/`);
    return data;
};

export const editOrderInfo = async ({ formdata, orderId }) => {
    const { data } = await axiosInstance.patch(
        `/api/v1/order/${orderId}/`,
        formdata
    );
    return data;
};

export const addOrder = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/order/`,
        formData
    );
    return data;
};

export const triggerRazorpayOrder = async (orderId) => {
    const { data } = await axiosInstance.post(`/api/v1/order/${orderId}/create-razorpay-order/`);
    return data;
};

export const createInvoiceForOrder = async (orderId) => {
    const { data } = await axiosInstance.post(`/api/v1/order/${orderId}/create-invoice/`);
    return data;
};

export const getInvoices = async (page=1, id, order, invoiceStatus, created, updated, invoiceURL) => {
    const { data } = await axiosInstance.get(
        `/api/v1/invoice/?page=${page}&id=${id}&order=${order}&status=${invoiceStatus}&created=${created}&updated=${updated}&invoice_url=${invoiceURL}`
    );
    return data;
};

export const getCreditNotes = async (page=1, id, invoice, status, creditNoteType, created, updated) => {
    const { data } = await axiosInstance.get(
        `/api/v1/credit-note/?page=${page}&id=${id}&invoice=${invoice}&status=${status}&credit_note_type=${creditNoteType}&created=${created}&updated=${updated}`
    );
    return data;
};

export const exportInvoiceGST = (createdAfter, createdBefore) =>
    axiosInstance.get(`/api/v1/invoice/export-gst/?created_after=${createdAfter}&created_before=${createdBefore}`, { responseType: 'blob' });

export const exportCreditNoteGST = (createdAfter, createdBefore) =>
    axiosInstance.get(`/api/v1/credit-note/export-gst/?created_after=${createdAfter}&created_before=${createdBefore}`, { responseType: 'blob' });

export const createCreditNote = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/credit-note/`,
        formData
    );
    return data;
};

export const getInvoiceByOrder = async (orderId) => {
    const { data } = await axiosInstance.get(
        `/api/v1/invoice/?order=${orderId}&status=PAID`
    );
    return data;
};

export const verifyEmail = async (token) => {
    const { data } = await axiosInstance.post(
            `/api/v1/verify-email/`,
            token
        )
    return data
};

export const resendVerificationEmail = async (formData) => {
    const { data } = await axiosInstance.post(
            `/api/v1/resend-verification-email/`,
            formData
        )
    return data
};

export const getBasicInfo = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/basic-info/`
    );
    return data;
};

export const getMerchantKYCIndiaInfo = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/merchant-kyc-india/`
    );
    return data;
};

export const addBasicInfo = async ({formData, basicInfoId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/basic-info/${basicInfoId}/`,
            formData
        )
    return data
};

export const addMerchantKYCIndia = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/merchant-kyc-india/`,
            formData
        )
    return data
};

export const sendPhoneOTP = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/phone-number-update-send-otp/`,
        formData
    )
    return data
};

export const verifyPhoneOTP = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/phone-number-update-verify-otp/`,
        formData
    )
    return data
};

export const getBusinessInfo = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/business-info/`
    );
    return data;
};

export const addBusinessInfo = async ({formData, businessInfoId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/business-info/${businessInfoId}/`,
            formData
        )
    return data
};

export const getAccountInfo = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/account-info/`
    );
    return data;
};

export const addAccountInfo = async ({formData, accountInfoId}) => {
    const { data } = await axiosInstance
        .put(
            `/api/v1/account-info/${accountInfoId}/`,
            formData
        )
    return data
};

export const getCreditTransactions = async (page=1) => {
    const { data } = await axiosInstance.get(
        `/api/v1/credit-transaction/?page=${page}`
    );
    return data;
};

export const getCreditBalance = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/credit-balance/`
    );
    return data;
};

export const passwordChange = async (formdata) => {
    console.log('formdataaaaaaaaaaaaaaaaaaaaaaaaaa', formdata)
    const { data } = await axiosInstance.post(
        `/api/v1/password-change/`,
        formdata
    )
    return data
};

export const getPlans = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/plan/`
    );
    return data;
};

export const getSettingsInfo = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/setting/`
    );
    return data;
};

export const getProductSettingsInfo = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/product-setting/`
    );
    return data;
};

export const getAddonProductSettingsInfo = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/add-on-product-setting/`
    );
    return data;
};

export const getProductGroupSettingsInfo = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/product-group-setting/`
    );
    return data;
};

export const getCustomerSettingsInfo = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/customer-setting/`
    );
    return data;
};

export const resetOrderToken = async (settingId) => {
    const { data } = await axiosInstance.post(`/api/v1/order-setting/${settingId}/reset-token/`);
    return data;
};

export const getOrderSettingsInfo = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/order-setting/`
    );
    return data;
};

export const getStorefrontSettingsInfo = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/storefront-setting/`
    );
    return data;
};

export const editProductSettings = async ({formData, settingId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/product-setting/${settingId}/`,
            formData
        )
    return data
};

export const editAddonProductSettings = async ({formData, settingId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/add-on-product-setting/${settingId}/`,
            formData
        )
    return data
};

export const editProductGroupSettings = async ({formData, settingId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/product-group-setting/${settingId}/`,
            formData
        )
    return data
};

export const editOrderSettings = async ({formData, settingId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/order-setting/${settingId}/`,
            formData
        )
    return data
};

export const editStorefrontSettings = async ({formData, settingId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/storefront-setting/${settingId}/`,
            formData
        )
    return data
};

export const getInvoiceSettingsInfo = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/invoice-setting/`
    );
    return data;
};

export const editInvoiceSettings = async ({formData, settingId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/invoice-setting/${settingId}/`,
            formData
        )
    return data
};

export const editCustomerSettings = async ({formData, settingId}) => {
    const { data } = await axiosInstance
        .patch(
            `/api/v1/customer-setting/${settingId}/`,
            formData
        )
    return data
};

export const addProductsAddOn = async (product, customer, add_on_products) => {
    const { data } = await axiosInstance.post('/api/v1/product-add-on-item/', {
        product,
        customer,
        add_on_products: add_on_products || []
    });
    return data;
};

export const addProductAddOn = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/product-add-on-item/`,
        formData
    );
    return data;
};

export const editProductAddOn = async (formData, productAddOnId) => {
    const { data } = await axiosInstance.put(
        `/api/v1/product-add-on-item/${productAddOnId}/`,
        formData
    );
    return data;
};

export const addProductGroupAddOn = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/product-group-add-on-item/`,
        formData
    );
    return data;
};

export const editProductGroupAddOn = async (formData, productAddOnId) => {
    const { data } = await axiosInstance.put(
        `/api/v1/product-group-add-on-item/${productAddOnId}/`,
        formData
    );
    return data;
};

export const phoneNumberUpdateSendOtp = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/phone-number-update-send-otp/`,
        formData
    );
    return data;
};


export const refund = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/refund/`,
        formData
    );
    return data;
};


export const phoneNumberUpdateVerifyOtp = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/phone-number-update-verify-otp/`,
        formData
    );
    return data;
};

export const getRefunds = async (page=1, id, order, referenceRefundId, referencePaymentId, refundType, amount, currency, instantRefund, refundStatus, refundReason,  created, updated) => {
    const { data } = await axiosInstance.get(
        `/api/v1/refund/?page=${page}&id=${id}&order=${order}&reference_refund_id=${referenceRefundId}&reference_payment_id=${referencePaymentId}&refund_type=${refundType}&amount=${amount}&currency=${currency}&instant_refund=${instantRefund}&refund_status=${refundStatus}&refund_reason=${refundReason}&created=${created}&updated=${updated}`
    );
    return data;
};

export const getBusinessCategory = async (page =1, id, user, name, created, updated, records) => {
    const { data } = await axiosInstance.get(
        `/api/v1/business-category/?records=${records}&page=${page}&id=${id}&user=${user}&name=${name}&created=${created}&updated=${updated}`,
    );
    return data;
};

export const getBusinessSubCategory = async (page =1, id, user, name, category, created, updated, records) => {
    const { data } = await axiosInstance.get(
        `/api/v1/business-sub-category/?records=${records}&page=${page}&id=${id}&user=${user}&name=${name}&category=${category}&created=${created}&updated=${updated}`
    );
    return data;
};

export const waitingList = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/waiting-list/`,
        formData
    );
    return data;
};

export const getMonthlyUsageSummary = async (page = 1) => {
    const { data } = await axiosInstance.get(
        `/api/v1/monthly-usage-summary/?page=${page}`
    );
    return data;
};

export const getMonthlyActiveItems = async (page = 1) => {
    const { data } = await axiosInstance.get(
        `/api/v1/monthly-active-item/?page=${page}`
    );
    return data;
};

export const getBillingInvoice = async (page = 1) => {
    const { data } = await axiosInstance.get(
        `/api/v1/billing-invoice/?page=${page}`
    );
    return data;
};

export const getBillingPayment = async (page = 1) => {
    const { data } = await axiosInstance.get(
        `/api/v1/billing-payment/?page=${page}`
    );
    return data;
};

export const getBillingPaymentMethod = async () => {
    const { data } = await axiosInstance.get(
        `/api/v1/billing-payment-method/`
    );
    return data;
};

export const setupBillingPaymentMethod = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/billing-payment-method/setup/`,
        formData
    );
    return data;
};

export const confirmBillingPaymentMethod = async (formData) => {
    const { data } = await axiosInstance.post(
        `/api/v1/billing-payment-method/confirm/`,
        formData
    );
    return data;
};

export const setDefaultBillingPaymentMethod = async (id) => {
    const { data } = await axiosInstance.post(
        `/api/v1/billing-payment-method/${id}/set-default/`
    );
    return data;
};

export const removeBillingPaymentMethod = async (id) => {
    const { data } = await axiosInstance.delete(
        `/api/v1/billing-payment-method/${id}/`
    );
    return data;
};

async function fetchAllPages(url) {
    const results = [];
    let page = 1;
    while (true) {
        const { data } = await axiosInstance.get(`${url}${url.includes('?') ? '&' : '?'}page=${page}`);
        if (Array.isArray(data?.results)) {
            results.push(...data.results);
            if (!data.next) break;
            page += 1;
        } else if (Array.isArray(data)) {
            results.push(...data);
            break;
        } else {
            break;
        }
    }
    return results;
}

export const getAllMonthlyUsageSummaries = async () => {
    return fetchAllPages(`/api/v1/monthly-usage-summary/`);
};

export const getAllBillingInvoices = async () => {
    return fetchAllPages(`/api/v1/billing-invoice/`);
};

export const getMonthlyActiveItemsByMonth = async (month, year, itemType) => {
    const params = new URLSearchParams();
    if (month) params.set('month', month);
    if (year) params.set('year', year);
    if (itemType) params.set('item_type', itemType);
    return fetchAllPages(`/api/v1/monthly-active-item/?${params.toString()}`);
};

export const getRazorpayCredentials = async () => {
    const { data } = await axiosInstance.get(`/api/v1/razorpay-credentials/`);
    return data;
};

export const createRazorpayCredentials = async (formData) => {
    const { data } = await axiosInstance.post(`/api/v1/razorpay-credentials/`, formData);
    return data;
};

export const updateRazorpayCredentials = async ({ id, formData }) => {
    const { data } = await axiosInstance.patch(`/api/v1/razorpay-credentials/${id}/`, formData);
    return data;
};

export const issueRefund = async (formData) => {
    const { data } = await axiosInstance.post(`/api/v1/issue-refund/`, formData);
    return data;
};

export const getDashboardStats = async (period = 'month') => {
    const { data } = await axiosInstance.get(`/api/v1/dashboard-stats/?period=${period}`);
    return data;
};

export const acknowledgeCartChangelog = async (cartId) => {
    const { data } = await axiosInstance.post(`/api/v1/cart/${cartId}/acknowledge-changelog/`);
    return data;
};
